import { MANUAL_PAYMENT_TYPE_ID } from "../../../../utils/manualPayment";

const PaymentMethod = ({ updateFields, paymentTypeId }) => {
  const selected = String(paymentTypeId || "2");

  const selectMethod = (id) => {
    updateFields({ paymentTypeId: String(id) });
  };

  return (
    <div className="w-full flex justify-center items-start min-h-[30vh] h-full px-4">
      <div className="w-full max-w-xl mt-8 bg-white rounded-xl shadow p-6">
        <h2 className="text-2xl font-semibold">Payment</h2>
        <p className="mt-2 text-gray-600 text-sm">
          Choose how you want to pay for this booking.
        </p>

        <div className="mt-6 flex flex-col gap-3">
          <button
            type="button"
            onClick={() => selectMethod("2")}
            className={`text-left rounded-xl border-2 p-4 transition-all ${
              selected === "2"
                ? "border-orange-500 bg-orange-50 shadow-sm"
                : "border-gray-200 hover:border-orange-300"
            }`}
          >
            <div className="flex items-start gap-3">
              <span
                className={`mt-1 h-4 w-4 rounded-full border-2 flex-shrink-0 ${
                  selected === "2"
                    ? "border-orange-500 bg-orange-500"
                    : "border-gray-300"
                }`}
              />
              <div>
                <p className="font-semibold text-gray-900">Online Payment (Stripe)</p>
                <p className="text-sm text-gray-600 mt-1">
                  Pay securely by card. Booking is confirmed after successful payment.
                </p>
              </div>
            </div>
          </button>

          <button
            type="button"
            onClick={() => selectMethod(MANUAL_PAYMENT_TYPE_ID)}
            className={`text-left rounded-xl border-2 p-4 transition-all ${
              selected === MANUAL_PAYMENT_TYPE_ID
                ? "border-orange-500 bg-orange-50 shadow-sm"
                : "border-gray-200 hover:border-orange-300"
            }`}
          >
            <div className="flex items-start gap-3">
              <span
                className={`mt-1 h-4 w-4 rounded-full border-2 flex-shrink-0 ${
                  selected === MANUAL_PAYMENT_TYPE_ID
                    ? "border-orange-500 bg-orange-500"
                    : "border-gray-300"
                }`}
              />
              <div>
                <p className="font-semibold text-gray-900">Manual Bank Transfer</p>
                <p className="text-sm text-gray-600 mt-1">
                  Transfer to our Lloyds account using the invoice number as payment
                  reference. An admin will verify payment manually.
                </p>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethod;
